import { Dispatch } from 'redux';
import { FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { FileState } from 'sos-common/js/commonTypes/fileupload.types';
import { FormBaseStore } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { FormFieldFile } from 'sos-common/js/commonTypes/formField.types';
import { deleteFileRedux, postFilesRedux } from '../../services/files.redux.service';
import { doValidateByState } from '../../services/validation.service';
import { makeTranslator } from 'sos-common/js/utils/translations';
import { ADD_FILE, IAddFileAction, IRemoveAction, REMOVE_FILE } from './files.actiontypes';
import { getFormConfig } from 'sos-eservice-common/js/config';
import { thunkGetStateFunc } from '../store.provider';
import { errorEvent } from './errors.actions';
import { setValidationResults } from './validationResults.action';
import { ResponseError } from 'sos-common/js/utils/ResponseError';

export function addFile(file: FileExtendedDetails, fieldName: string) {
  return {
    type: ADD_FILE,
    payload: file,
    fieldName,
  } as IAddFileAction;
}

export type addFileActionFunc = (fileField: FormFieldFile) => void;
export function addFilesAction(fileField: FormFieldFile) {
  const config = getFormConfig();
  const file = fileField.value.filter((f) => !f.FileId)[0];
  const fieldName = fileField.fieldName;
  let error: ResponseError = null;
  let friendlyErrorMessage = '';
  return function (dispatch: Dispatch, getState: thunkGetStateFunc<FormBaseStore<any>>) {
    const { globals } = getState();
    const { orderId, translations } = globals;
    const Translate = makeTranslator(translations);

    dispatch(addFile(file, fieldName));

    doValidateByState(getState())
      .then((validationResults) => {
        return dispatch(setValidationResults(validationResults));
      })
      .then((_) => {
        return postFilesRedux(file, orderId, fieldName);
      })
      .then((postFilesResponse) => {
        if (postFilesResponse instanceof ResponseError) {
          throw postFilesResponse;
        } else {
          return dispatch(addFile(postFilesResponse, fieldName));
        }
      })
      .catch((err: ResponseError) => {
        friendlyErrorMessage = err.body.errorMessage || config.errorMessageResolver(addFile(file, fieldName));
        error = err;
        dispatch(removeFile(file, fieldName));

        dispatch(
          errorEvent({
            error: err,
            fieldName: fileField.fieldName,
            friendlyMessage: friendlyErrorMessage,
          })
        );
      })
      .then((_) => {
        return doValidateByState(getState());
      })
      .then((validationResults) => {
        /*
        if (error) {
          validationResults.push({
            FieldName: fieldName,
            ValidationText: friendlyErrorMessage
          });
          error = null;
        }*/
        return dispatch(setValidationResults(validationResults));
      });
  };
}

export function removeFile(file: FileExtendedDetails, fieldName: string) {
  return {
    fieldName,
    payload: file,
    type: REMOVE_FILE,
  } as IRemoveAction;
}

export type removeFileActionFunc = typeof removeFilesAction;
export function removeFilesAction(file: FileExtendedDetails, fieldName: string) {
  return function (dispatch: Dispatch, getState: thunkGetStateFunc<FormBaseStore<any>>) {
    dispatch(removeFile(file, fieldName));

    const { globals } = getState();
    const { orderId } = globals;
    deleteFileRedux(file, orderId, fieldName)
      .catch((err) => {
        dispatch(addFile(file, fieldName));
        dispatch(
          errorEvent({
            error: err,
            fieldName,
            friendlyMessage: 'Kunde inte radera filen',
          })
        );
      })
      .then((_) => {
        return doValidateByState(getState());
      })
      .then((validationResults) => {
        dispatch(setValidationResults(validationResults));
      });
  };
}
